import { Heading } from '@app/app/_components/Heading/Heading';
import { ChoiceButtonInput } from '@app/app/_components/Input/ChoiceButtonInput';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { ChecklistItem } from '@app/app/_components/ChecklistItem/ChecklistItem';
import { ProductDataRider } from '@app/domain/model/eshop/transport/ProductDataRider';
import { splitNumber } from '@app/lib/split-number/splitNumber';
import { useTranslations } from 'next-intl';
import { ChangeEvent } from 'react';

interface Props {
    handleRidersChange: (e: ChangeEvent<HTMLInputElement>) => void;
    selectedRiders: ProductDataRider[];
    riders: ProductDataRider[];
}

export function AdditionalRisksStep({ handleRidersChange, selectedRiders, riders }: Props) {
    const t = useTranslations();

    const riderOptions = riders.map(rider => ({
        value: rider.riskPackageCode,
        label: (
            <div className="flex flex-col items-start gap-3 font-medium">
                <Heading level="h4">{rider.riderName}</Heading>
                <div className="flex flex-row items-start gap-1">
                    <Paragraph isBold size="medium">
                        {splitNumber(rider.premiums.premium).integerPart}
                    </Paragraph>
                    <Paragraph isBold size="tiny">
                        {splitNumber(rider.premiums.premium).fractionalPart}
                    </Paragraph>
                    <Paragraph isBold>€</Paragraph>
                    {rider.premiums.risks[0].sumInsured && rider.premiums.risks[0].sumInsured !== 0 && (
                        <Paragraph isGray>
                            / {t.rich('eshop.home.insuranceAmount', { amount: rider.premiums.risks[0].sumInsured })}
                        </Paragraph>
                    )}
                </div>
            </div>
        ),
        details: (
            <div className="flex flex-col gap-2">
                {t.rich(`eshop.home.rider.${rider.riskPackageCode}`, {
                    li: children => <ChecklistItem>{children}</ChecklistItem>,
                })}
            </div>
        ),
    }));

    return (
        <ChoiceButtonInput
            type="checkbox"
            name="selectedRisks"
            onChange={handleRidersChange}
            value={selectedRiders.map(rider => rider.riskPackageCode)}
            options={riderOptions}
        />
    );
}
